import { api } from "./api";

/**
 * Thin wrappers around Binshare's Guideline-1.2 moderation endpoints. Keeps
 * the request shape consistent everywhere Report/Block is rendered.
 */

export const REPORT_REASON_OPTIONS = [
  { value: "harassment", label: "Harassment or hate speech" },
  { value: "spam", label: "Spam or unwanted contact" },
  { value: "scam", label: "Scam / fraud / off-platform payment" },
  { value: "inappropriate", label: "Inappropriate or illegal content" },
  { value: "impersonation", label: "Impersonation" },
  { value: "safety", label: "Safety concern on the job" },
  { value: "other", label: "Other (please describe)" },
];

export async function reportContent({ userId, targetKind, targetId, reason, details }) {
  const { data } = await api.post(
    "/reports",
    { target_kind: targetKind, target_id: targetId, reason, details: details || null },
    { params: { user_id: userId } },
  );
  return data;
}

export async function blockUser({ userId, blockedUserId, reason }) {
  const { data } = await api.post(
    "/users/blocks",
    { blocked_user_id: blockedUserId, reason: reason || null },
    { params: { user_id: userId } },
  );
  return data;
}

export async function unblockUser({ userId, blockedUserId }) {
  const { data } = await api.delete(`/users/blocks/${blockedUserId}`, {
    params: { user_id: userId },
  });
  return data;
}

export async function listBlocks({ userId }) {
  const { data } = await api.get("/users/blocks", { params: { user_id: userId } });
  return data;
}
